import createSvgIcon from "./utils/create_icon"

const EnvelopeOutline = createSvgIcon(<path clipRule="evenodd" d="M4 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm16 3.412V7H4v1.412l8 4.444zM4 10.699V17h16v-6.3l-7.514 4.174a1 1 0 0 1-.972 0z" fill="currentColor" fillRule="evenodd" />, "EnvelopeOutline")
export default EnvelopeOutline
